import React from 'react'

import './footer.css';

const Footer = () => {
  return (
    <footer className="Footer">
        <p></p>
    </footer>
  )
}

export default Footer;